import React, { useEffect } from "react";
import "./generic.css";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";

interface NavlistProps {
    navigateTo: string,
    label: string,
}

const NavList: React.FC<NavlistProps> = (props) => {
    return (
        
        <Link className="nav-list" to={props?.navigateTo}>
            <div className="small-square"></div>
            {props.label}
        </Link>
            
    );
  };
  export default NavList;